import { NgModule, Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "hSlashSpacer",
})
export class SpacesAroundSlashesPipe implements PipeTransform {
    /**
     * (?!(\/\s+|\s+\/) Non-capturing group for slash space or space slash.
     * \/ Capturing group for all slashes.
     */
    private REGEXP_SLASH_WITHOUT_SPACES = /(?!(\/\s+|\s+\/))\//gi;

    /**
     * Replace slashes (Color1/Color2) by spaced slashes (Color1 / Color2).
     */
    public transform(value: string): string {
        return value.replace(this.REGEXP_SLASH_WITHOUT_SPACES, " / ");
    }
}

@NgModule({
    declarations: [SpacesAroundSlashesPipe],
    exports: [SpacesAroundSlashesPipe],
})
export class SpacesAroundSlashesPipeModule {}
